<template>
    <div class="searched-attachment-list" ref="searchedAttachmentScrollBox"  v-if="ajaxDone">
            <h1 class="search-key" v-text="$route.query.searchKey"></h1>
            <section class="attachment-list box_search" :class="$style['box_search']" v-for="(attachment,index) in AllAttachmentListList" :key="index" @click="attachmentVisited(index)">
                <div class="search-list-item" @click="openFile(attachment.Url,attachment.Name)">
                    <i class="attachment-link"></i>
                    <span v-html="attachment.Name" class="attachment-content" :class="{'attchment-visited':attachment.visited==true}"></span>
                </div>
            </section>
            <div class="noData" v-if="!AllAttachmentListList.length">暂无数据</div>
            <loading-more></loading-more>
    </div>
</template>

<script>
import {SEARCH} from '@/api'
import dsBridge from '@/utils/dsbridge'
import loadingMore from '@/components/loadingMore'
import store from '@/store/index'

export default {
    name: 'attachmentList',
    components: {loadingMore},
    data() {
        return {
            lastSearchKey:'',
            lastSearchNodeId:'',
            showBottomBar:false,
            ajaxDone:false,
            AllAttachmentListList: [],
            pageIndex: 1,
            pageSize: 15,
            pageCount: 1,
            prevAjaxEnd: true
        }
    },
    computed: {
        authType() {
            return localStorage.AUTH_TYPE
        }
    },
    mounted() {
        this.initData()
        this.$nextTick(()=>{
            document.getElementById('search-page').addEventListener('scroll',this.scrollHandle,false)
        })
    },
    activated(){
        document.getElementById('search-page').addEventListener('scroll',this.scrollHandle,false)
        document.getElementById('search-page').scrollTop = this.scrollTop
        if(this.$route.query.searchKey !== this.lastSearchKey || this.$route.query.searchNodeId !== this.lastSearchNodeId) {
            this.initData()
        }else{
            //是同一个搜索结果，再记录
            this.showBottomBar ? this.$store.commit('setBottomBar',this.showBottomBar) : this.$store.commit('setBottomBar','')
        }
    },
    methods: {
        scrollHandle() {
            if(!this.$refs.searchedAttachmentScrollBox) return;
            let windowH = document.getElementById('search-page').clientHeight;
            let pageH = this.$refs.searchedAttachmentScrollBox ?  this.$refs.searchedAttachmentScrollBox.offsetHeight : 0;
            let windowScrollTop = document.getElementById('search-page').scrollTop;
            let leftTop = pageH - windowH - windowScrollTop;   //剩余高度(页面底部与视口底部的距离)

            // 如果剩余高度小于.18倍屏高 或者  滚动高度超过 .82倍屏高  不要问为什么是 0.18 ， 问就是sixsixsix
            if (leftTop < 0.18*windowH || windowScrollTop> 0.82*windowH) {
                this.$store.commit('setBottomBar','slide-up');
            }
            if (leftTop <= 0) {
                this.loadMore()
            }
        },
        openFile(src, htmlFileName) {

            let lastIndex = htmlFileName.lastIndexOf('.')  // 文件名最后一个点的索引
            let fileName = htmlFileName.substring(0, lastIndex)  // 带有html标签的文件名
            let fileType = htmlFileName.substring(lastIndex + 1)  // 文件类型
            let formatFileName = htmlFileName.replace(new RegExp(/<.+?>/, 'g'), '')  // 文件名

            if (this.authType === "APOLLO") {
                dsBridge.call('ApolloApp.invokeAsyn', {
                    methodName: "openFile",
                    params: {
                        "url": src,
                        "suffix": fileType,
                        "file_name": formatFileName
                    }
                }, function (res) {
                    console.log('error', res);
                })
                return
            }
            if (this.authType === 'TOOLKIT') {
                // docs: https://confluence.nevint.com/pages/viewpage.action?pageId=165983913
                dsBridge.call('NIOMateBridge.openFileByInstalledApp', {
                    "url": src
                }, function (res) {
                    console.log('---', res)
                })
                return
            }
            
            location.href = src
        },
        initData() {
            this.showBottomBar = false
            this.lastSearchKey = this.$route.query.searchKey
            this.lastSearchNodeId = this.$route.query.searchNodeId
            this.scrollTop = 0
            this.ajaxDone = false
            this.AllFaqList = []
            this.pageIndex = 1
            this.pageCount = 1
            SEARCH.SearchingAttachment({
                Keywords: this.$route.query.searchKey,
                NodeId: this.$route.query.searchNodeId,
                PageIndex: this.pageIndex,
                PageSize: this.pageSize
            }).then((res) => {
                this.AllAttachmentListList = res.Data.List || [];
                this.pageCount = Math.ceil(res.Data.TotalCount / this.pageSize);
                this.ajaxDone = true;

                // 如果有结果，延迟判断是否有滚动，如果没有滚动，就让底部提问栏渐显上来
                let timer = setTimeout(()=>{
                    let windowH = document.getElementById('search-page').clientHeight;
                    let pageH = this.$refs.searchedAttachmentScrollBox.offsetHeight;
                    // 如果没有出现滚动
                    if(pageH <= windowH) {
                        this.$store.commit('setBottomBar','fade-up-delay');
                    }
                    clearTimeout(timer)
                },1000)
            }).catch(()=>{
                this.ajaxDone = true
            })
        },
        loadMore() {
            if (!this.prevAjaxEnd) return
            if (this.pageIndex >= this.pageCount) return
            this.prevAjaxEnd = false
            store.commit('SET_LOADING_POSITION', 'bottom')
            SEARCH.SearchingAttachment({
                Keywords: this.$route.query.searchKey,
                PageIndex: ++this.pageIndex,
                PageSize: this.pageSize
            }).then((res) => {
                this.AllAttachmentListList = this.AllAttachmentListList.concat(res.Data.List)
                this.$nextTick(() => {
                    this.prevAjaxEnd = true
                    store.commit('SET_LOADING_POSITION', 'middle')
                })
            }).catch(() => {
                this.prevAjaxEnd = true
                store.commit('SET_LOADING_POSITION', 'middle')
            })
        },
        attachmentVisited(index) {
            this.$set(this.AllAttachmentListList[index], 'visited', true)
        }
    },
    beforeRouteLeave(to, from, next) {
        this.scrollTop = document.getElementById('search-page').scrollTop
        this.showBottomBar = this.$store.getters.bottomBar
        this.$store.commit('setBottomBar','')
        document.getElementById('search-page').removeEventListener('scroll', this.scrollHandle)
        next()
    }
}
</script>

<style lang="scss" type="text/scss" scoped>
    .searched-attachment-list {
        padding: 0 j(50);
        padding-bottom: j(180);
        .search-key {
            padding-top: j(36);
            margin-bottom: j(56);
            font-size: j(48);
            font-weight: 700;
            color: #363c54;
        }

        .attachment-list {
            padding: j(40) 0;
            font-size: j(28);
            font-weight: 400;
            color: #363c54;
            word-break: break-word;
            position: relative;
            border-bottom: 1px solid #f1f2f3;

            &:last-child {
                border: none;
            }
        }

        .noData {
            width: 100%;
            margin: 0 auto;
            text-align: center;
            color: #ccc;
            font-size: j(30);
        }

        .search-item-title {
            font-size: j(28);
            color: #363C54;
            display: block;
        }

        .search-item-content {
            font-size: j(28);
            margin-top: j(20);
            color: #696D7F;

            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            display: -webkit-box;
            /*!autoprefixer: off */
            -webkit-box-orient: vertical;
            /*autoprefixer: on */
            -webkit-line-clamp: 2;
        }

        .search-list-item {
            display: flex;
            align-items: center;
            font-size: j(32);
            color: #00BCBC;
        }

        .attchment-visited {
            color: #009292 !important;
        }

        .attachment-link {
            display: inline-block;
            height: j(41);
            width: j(41);
            margin-right: j(13);
            background: url('/static/images/attachment_link.png') no-repeat;
            background-size: 100% 100%;
        }

        .attachment-content {
            width: 100%;
            font-size: j(32);
            color: #00BCBC;
            display: block;

            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            display: -webkit-box;
            /*!autoprefixer: off */
            -webkit-box-orient: vertical;
            /*autoprefixer: on */
            -webkit-line-clamp: 2;

        }
    }

    @import "./animation.scss";
</style>


<style lang="scss" module>
    .box_search strong {
        color: #00bebe;
    }
</style>



// WEBPACK FOOTER //
// src/views/search/attachmentList.vue